import EcoSpace from 'eco-design/base/eco-space';
import PlaneCard from '../Common/PlaneCard';
import { useLang } from '@/i18n';

export default function SectionSolar() {
    const { t } = useLang('theProduct.SectionSolar');

    return (
        <>
            <PlaneCard
                title={t('title')}
                desc={t('desc')}
                pc="https://websiteoss.ecoflow.com/upload/image/1748331259329/solar.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1748331267517/solar_h5.jpg"
            />
            <EcoSpace />
        </>
    );
}
